export const BASE_URL = "https://api-crm.electrovel.com.ua";
// export const BASE_URL = "http://localhost:3001";
